import React, { Component } from 'react';
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Table } from 'react-bootstrap';
import 'react-table/react-table.css'
import 'react-dropdown/style.css';
import './style.css';
import ReactTable from "react-table";
import dashboardRequest from '../../utils/dashboardRequest';

const summaryValueStyle = { textAlign: 'center', fontSize: '12px', fontWeight: 'bold' };

class Content extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
      }

    constructor(props) {
        super(props);              

            this.state = {
            orders: [],
            loading: false,
            error: '',
            orderStatus: 'all',
            userToken: localStorage.getItem('userToken'),
            sortOptions: [
              {
                id: 'count_outstanding',
                desc: true,
              },
            ]
        };       
              
    }    

    componentDidMount() {     
      this.getOrders();
    }   

    componentWillUnmount() {
      this.unmounted = true;
    }

    getOrders = () => {
      this.setState({ loading: true, error: '' });
      return dashboardRequest('/reports/dash-orders/')
        .then(orders => {
          if (!this.unmounted) this.setState({ orders, loading: false });
        })
        .catch(error => {
          console.error('Error fetching dashboard summary:', error);
          if (!this.unmounted) this.setState({ loading: false, error: error.message });
        });
    }

    handleStatusClick = (e) => {
    e.preventDefault();    
    
        const target = e.target;
    
        e.target.value = null; 
    }

    onStatusClick = i => {      
      this.getOrders(process.env.REACT_APP_NODE_ROOT_URL+'/orders/o/status/'+i);
    }

    onMethodClick = i => {      
      this.getOrders(process.env.REACT_APP_NODE_ROOT_URL+'/orders/o/method/'+i);
    }

    render(){
        const statusTotals = this.state.orders.reduce((totals, order) => {
          totals.count_new += Number(order.count_new) || 0;
          totals.count_process += Number(order.count_process) || 0;
          totals.count_ready += Number(order.count_ready) || 0;
          totals.count_shipped += Number(order.count_shipped) || 0;
          return totals;
        }, { count_new: 0, count_process: 0, count_ready: 0, count_shipped: 0 });

        const outstandingTotal = statusTotals.count_new + statusTotals.count_process + statusTotals.count_ready;

        return (
        <div className="page-wrapper">
            
            <div className="container-fluid">
               
                <div className="row">					
                    <div className="col-lg-12">
                                 
                        <div className="card">
                        
                            <div className="card-title"> 
                            <h3>
                              <a data-toggle="collapse" href="#collapseOutgoing" aria-expanded="true" aria-controls="collapseOutgoing" id="heading-example" className="d-block">                                
                              <h3 className="text-primary">Order Summary</h3>
                                <i className="fa fa-chevron-down pull-right"></i>
                              </a>
                            </h3>
                            </div>
                            <div className="collapse show" id="collapseOutgoing">
                            
                            <div className="card-body">
                            {this.state.error && <div role="alert" className="alert alert-danger">{this.state.error}</div>}
                            <div className="table-responsive">
                               
                            <ReactTable
                              ref={(r) => (this.reactTable = r)}
                              data={this.state.orders}
                              sorted={this.state.sortOptions}
                              onSortedChange={(val) => {
                                this.setState({ sortOptions: val });                                
                              }}
                              filterable
                              noDataText={this.state.loading ? 'Loading dashboard...' : 'No summary data found'}
                              loading={this.state.loading}
                              defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                              }
                              columns={[
  {
    Header: '',
    columns: [
      {
        Header: 'Client',
        accessor: 'cl_name',
        Cell: row => <strong>{row.value}</strong>,
        width: 140
      },
      {
        Header: `New (${statusTotals.count_new})`,
        accessor: 'count_new',
        Cell: row => <strong>{row.value}</strong>,
        width: 70,
        style: summaryValueStyle
      },
      {
        Header: `Processing (${statusTotals.count_process})`,
        accessor: 'count_process',
        Cell: row => <strong>{row.value}</strong>,
        width: 85,
        style: summaryValueStyle
      },
      {
        Header: `Ready for Pickup (${statusTotals.count_ready})`,
        accessor: 'count_ready',
        Cell: row => <strong>{row.value}</strong>,
        width: 110,
        style: summaryValueStyle
      },
      {
        Header: `Outstanding (${outstandingTotal})`,
        id: 'count_outstanding',
        accessor: d =>
          (parseInt(d.count_new) || 0) +
          (parseInt(d.count_process) || 0) +
          (parseInt(d.count_ready) || 0),
        Cell: row => <strong>{row.value}</strong>,
        filterable: false,
        width: 115,
        style: summaryValueStyle
      },
      {
        Header: `Shipped (${statusTotals.count_shipped})`,
        accessor: 'count_shipped',
        Cell: row => <strong>{row.value}</strong>,
        width: 100,
        style: summaryValueStyle
      },
      {
        Header: 'Rate/Hr',
        accessor: 'cl_order_fill_rate',
        Cell: row => <strong>{row.value}</strong>,
        width: 72,
        style: summaryValueStyle,
        filterable: false
      },
      {
        Header: 'Hrs Req.',
        accessor: 'Hrs Required',
        Cell: row => <strong>{row.value}</strong>,
        width: 65,
        style: summaryValueStyle,
        filterable: false
      },
      {
        Header: 'Urgent',
        accessor: 'count_urgent',
        Cell: row => <strong>{row.value}</strong>,
        width: 55,
        style: summaryValueStyle
      },
      {
        Header: 'Hold',
        accessor: 'count_hold',
        Cell: row => <strong>{row.value}</strong>,
        width: 55,
        style: summaryValueStyle
      },
      {
        Header: 'Canceled',
        accessor: 'count_canceled',
        Cell: row => <strong>{row.value}</strong>,
        width: 60,
        style: summaryValueStyle
      },
      {
        Header: 'Mis-shipped',
        accessor: 'count_missed',
        Cell: row => <strong>{row.value}</strong>,
        width: 70,
        style: summaryValueStyle
      },
    ],
  },
]}

                            />


                           </div>

                            </div>
                        </div>
                    </div>
                </div>               
                <div className="row">   
                <div className="col-lg-4">
                        
                      </div>
                  </div>


              </div>

              <footer className="footer"> © 2024 All rights reserved. Brand Warehouse</footer>

            </div>
        </div>
                )
    }
}
export default withRouter(Content);